import { z } from 'zod';
export const getBadgesWithAnalyticsRequestSchema = z.object({
    limit: z.number().max(100),
    offset: z.number(),
});
export const badgesWithAnalyticsSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().optional(),
    expirationIntervalMonths: z.number().positive(),
    organizationIds: z.string().uuid().array(),
    validAccountBadgesCount: z.number(),
    invalidAccountBadgesCount: z.number(),
});
export const getBadgesWithAnalyticsResponseSchema = z.object({
    total: z.number(),
    rows: badgesWithAnalyticsSchema.array(),
});
export const getBadgesWithAnalyticsFunctionDef = {
    name: 'getBadgesWithAnalytics',
    requestSchema: getBadgesWithAnalyticsRequestSchema,
    responseSchema: getBadgesWithAnalyticsResponseSchema,
};
